export default function Advisory() {
  return (
    <section className="py-24 bg-slate-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-slate-900 mb-8 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
            Advisory &amp; Coalition Support
          </h2>
          
          <div className="bg-white p-10 shadow-lg border-t-4 border-red-800">
            <p className="text-xl text-slate-700 leading-relaxed mb-8">
              Our work is informed by a diverse coalition of technical and civil rights leaders, including:
            </p>

            <div className="grid md:grid-cols-3 gap-8 mb-8">
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-red-800 text-white mx-auto mb-4">
                  <i className="ri-user-star-line text-4xl"></i>
                </div>
                <h3 className="font-serif text-xl font-bold text-slate-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Dolores Huerta
                </h3>
                <p className="text-slate-600">President, Dolores Huerta Foundation</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-slate-900 text-white mx-auto mb-4">
                  <i className="ri-user-star-line text-4xl"></i>
                </div>
                <h3 className="font-serif text-xl font-bold text-slate-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Angel Luevano
                </h3>
                <p className="text-slate-600">Civil Rights Leader</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-red-800 text-white mx-auto mb-4">
                  <i className="ri-team-line text-4xl"></i>
                </div>
                <h3 className="font-serif text-xl font-bold text-slate-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Technical Safety Community
                </h3>
                <p className="text-slate-600">Aligned with Stuart Russell's principles</p>
              </div>
            </div>

            <div className="bg-slate-900 text-white p-8 text-center">
              <p className="text-lg leading-relaxed">
                Our coalition bridges the gap between <strong>civil rights advocacy</strong> and <strong>technical AI safety</strong>, ensuring that policy solutions are both technically sound and socially just.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
